/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class follows the swagger code generator conventions (see openapi/readme.md); it can be
 * replaced by the generated one on the next merge.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams }               from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { FileConnection } from '../model/fileConnection';
import { FileConnectionOptionDTO } from '../model/fileConnectionOptionDTO';

import { BASE_PATH }                                         from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ConfiguratorFileConnectionService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    private buildHeaders(xDataStoreID: string, operation: string, withBody: boolean): HttpHeaders {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling ' + operation + '.');
        }
        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));

        const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(['application/json']);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }
        if (withBody) {
            const contentTypeSelected = this.configuration.selectHeaderContentType(['application/json']);
            if (contentTypeSelected != undefined) {
                headers = headers.set('Content-Type', contentTypeSelected);
            }
        }
        return headers;
    }

    /**
     * Lister les connexions S3 / FTP que l&#39;appelant peut gérer (secrets masqués)
     * @param xDataStoreID X-DataStoreID
     * @param partner partner
     */
    public getFileConnectionsUsingGET(xDataStoreID: string, partner?: string): Observable<FileConnection[]> {
        const headers = this.buildHeaders(xDataStoreID, 'getFileConnectionsUsingGET', false);
        let queryParameters = new HttpParams();
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', partner);
        }
        return this.httpClient.get<FileConnection[]>(
            `${this.basePath}/api/file-connections`,
            { withCredentials: this.configuration.withCredentials, headers, params: queryParameters }
        );
    }

    /**
     * Lister les connexions proposées à un import / export d&#39;un affilié (ou du tenant si vide)
     * @param xDataStoreID X-DataStoreID
     * @param partner partner
     */
    public getFileConnectionOptionsUsingGET(xDataStoreID: string, partner?: string): Observable<FileConnectionOptionDTO[]> {
        const headers = this.buildHeaders(xDataStoreID, 'getFileConnectionOptionsUsingGET', false);
        let queryParameters = new HttpParams();
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', partner);
        }
        return this.httpClient.get<FileConnectionOptionDTO[]>(
            `${this.basePath}/api/file-connections/options`,
            { withCredentials: this.configuration.withCredentials, headers, params: queryParameters }
        );
    }

    /**
     * Récupérer une connexion S3 / FTP (secrets masqués)
     * @param xDataStoreID X-DataStoreID
     * @param id id
     */
    public getFileConnectionUsingGET(xDataStoreID: string, id: string): Observable<FileConnection> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getFileConnectionUsingGET.');
        }
        const headers = this.buildHeaders(xDataStoreID, 'getFileConnectionUsingGET', false);
        return this.httpClient.get<FileConnection>(
            `${this.basePath}/api/file-connections/${encodeURIComponent(String(id))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    /**
     * Créer une connexion S3 / FTP
     * @param xDataStoreID X-DataStoreID
     * @param connection connection
     */
    public createFileConnectionUsingPOST(xDataStoreID: string, connection: FileConnection): Observable<FileConnection> {
        if (connection === null || connection === undefined) {
            throw new Error('Required parameter connection was null or undefined when calling createFileConnectionUsingPOST.');
        }
        const headers = this.buildHeaders(xDataStoreID, 'createFileConnectionUsingPOST', true);
        return this.httpClient.post<FileConnection>(
            `${this.basePath}/api/file-connections`,
            connection,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    /**
     * Modifier une connexion S3 / FTP (un secret vide ou masqué est conservé)
     * @param xDataStoreID X-DataStoreID
     * @param id id
     * @param connection connection
     */
    public updateFileConnectionUsingPUT(xDataStoreID: string, id: string, connection: FileConnection): Observable<FileConnection> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateFileConnectionUsingPUT.');
        }
        if (connection === null || connection === undefined) {
            throw new Error('Required parameter connection was null or undefined when calling updateFileConnectionUsingPUT.');
        }
        const headers = this.buildHeaders(xDataStoreID, 'updateFileConnectionUsingPUT', true);
        return this.httpClient.put<FileConnection>(
            `${this.basePath}/api/file-connections/${encodeURIComponent(String(id))}`,
            connection,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    /**
     * Supprimer une connexion S3 / FTP (refusé si elle est utilisée)
     * @param xDataStoreID X-DataStoreID
     * @param id id
     */
    public deleteFileConnectionUsingDELETE(xDataStoreID: string, id: string): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteFileConnectionUsingDELETE.');
        }
        const headers = this.buildHeaders(xDataStoreID, 'deleteFileConnectionUsingDELETE', false);
        return this.httpClient.delete<any>(
            `${this.basePath}/api/file-connections/${encodeURIComponent(String(id))}`,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

    /**
     * Tester une connexion S3 / FTP sans l&#39;enregistrer
     * @param xDataStoreID X-DataStoreID
     * @param connection connection
     */
    public testFileConnectionUsingPOST(xDataStoreID: string, connection: FileConnection): Observable<{ [key: string]: string }> {
        if (connection === null || connection === undefined) {
            throw new Error('Required parameter connection was null or undefined when calling testFileConnectionUsingPOST.');
        }
        const headers = this.buildHeaders(xDataStoreID, 'testFileConnectionUsingPOST', true);
        return this.httpClient.post<{ [key: string]: string }>(
            `${this.basePath}/api/file-connections/test`,
            connection,
            { withCredentials: this.configuration.withCredentials, headers }
        );
    }

}
